import API from "../../helpers/API";
import {
  SHOW_LOADER,
  HIDE_LOADER,
  GET_ADD_DEPARTMENT_LIST,
  SET_DEPARTMENT_TABLE_COUNTER,
  GET_USER_LISTING,
  SET_UNAPPROVED_USER_LIST,
  GET_USER_LISTING_COUNTER,
  GET_ADD_ROLE_LIST,
  SET_ROLE_TABLE_COUNTER,
  GET_USER_BY_SUPERVISIOR,
} from "../../common/constants/ActionTypes";
import {
  ADD_NEW_USER,
  CREATE_DEPARTMENT,
  GET_DEPARTMENT_LIST,
  GET_USER_LIST,
  GET_USER_UNAPPROVED_DATA,
  SAVEDEPARTMENTDATA,
  SET_APPROVALUSER,
  CREATE_ROLE,
  GET_ROLE_LIST,
  GET_USER,
} from "../../common/constants/endpoints";
import { toastr } from "react-redux-toastr";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";

export const saveDepartmentData = (data, onCancelButton) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async function (dispatch) {
    let response;
    try {
      if (data?.id) {
        response = await API.patch(`${CREATE_DEPARTMENT}`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        response = await API.post(`${CREATE_DEPARTMENT}`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      if (response) {
        // let msg = response && response.data ? response.data : response.message;
        // toastr.success(msg);
        handleResponseMessage(response);
        dispatch(getDepartmentList());
        onCancelButton();
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const saveNewUserData = (data) => {
  let rowPerPage = 10;
  let listCurrentPage = 0;
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async function (dispatch) {
    let response;
    try {
      response = await API.post(`${ADD_NEW_USER}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        // let msg =
        //   response && response.data ? response.data.message : response.message;
        // // setDepartmentName('');
        // // setDepartmentDescription('');
        // toastr.success(msg);
        handleResponseMessage(response);
        dispatch(getUserList(listCurrentPage, rowPerPage));
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  }

}
export const getDepartmentList = () => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_DEPARTMENT_LIST}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          type: GET_ADD_DEPARTMENT_LIST,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getUserList = (listCurrentPage, rowPerPage) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_USER_LIST}/${listCurrentPage}/${rowPerPage}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          type: GET_USER_LISTING,
          payload: response.data,
        });
        dispatch({
          type: GET_USER_LISTING_COUNTER,
          payload: listCurrentPage * rowPerPage,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAllApprovalUserList = () => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(`${GET_USER_UNAPPROVED_DATA}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let allDone = false;
      if (response) {
        dispatch({
          type: SET_UNAPPROVED_USER_LIST,
          payload: response.data,
        });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_UNAPPROVED_USER_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const UserApprovalEntity = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.post(SET_APPROVALUSER, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);

      let successMessage =
        response && response.data ? response.data.message : response.message;
      toastr.success(successMessage);
      dispatch(getAllApprovalUserList());
    } catch (error) {
      handleError(error);
    }
  };
};

export const saveRoleData = (
  roleName,
  roleDescription,
  setRoleName,
  setRoleDescription
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async function (dispatch) {
    let response;
    try {
      // response = await API.post(
      //   `${CREATE_ROLE}`,
      //   {
      //     name: roleName,
      //     description: roleDescription,
      //   },
      //   {
      //     headers: { Authorization: `Bearer ${token}` },
      //   }
      // );
      let requestData = {
        name: roleName,
        description: roleDescription,
      }
      response = await API.post(CREATE_ROLE, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        // let msg = response && response.data ? response.data : response.message;
        handleResponseMessage(response);
        setRoleName("");
        setRoleDescription("");
        // toastr.success(msg);
        // window.location.reload();
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getRoleList = () => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_ROLE_LIST}`,

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          type: GET_ADD_ROLE_LIST,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getUserListing = () => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_USER}`,

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          type: GET_USER_BY_SUPERVISIOR,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
}

export const deleteRoleData = (id, getRoleList, roleName, roleDescription) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async function (dispatch) {
    let response;
    try {
      response = await API.patch(
        `${CREATE_ROLE}`,
        {
          id: id,
          name: roleName,
          description: roleDescription,
          isActive: false,
          isDeleted: true,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        handleResponseMessage(response);
        // let msg =
        //   response && response.data ? response.data : response.message;
        // toastr.success(msg);
      }

      dispatch(getRoleList());

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  }

};

export const editRoleData = (roleId, updatedRoleData, getRoleList) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async function (dispatch) {
    let response;
    try {
      response = await API.patch(
        `${CREATE_ROLE}`,
        {
          id: roleId,
          name: updatedRoleData.name,
          description: updatedRoleData.description,
          isActive: updatedRoleData.isActive !== undefined && updatedRoleData.isActive !== null ? updatedRoleData.isActive : true,
          isDeleted: false,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        handleResponseMessage(response);
        // let msg =
        //   response && response.data ? response.data : response.message;
        // toastr.success(msg);
      }

      dispatch(getRoleList());

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  }

};

export const showLoader = () => {
  return (dispatch) => {
    dispatch({
      type: SHOW_LOADER,
    });
  };
};

export const hideLoader = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_LOADER,
    });
  };
};
